import React from "react";
import PaymentSummaryItem from "./PaymentSummaryItem";
import dayjs from "dayjs";
import SimpleBox from "../layout/container/SimpleBox";

const PaymentSummary = ({ payments, paymentType }) => {

    const paymentList = payments.filter((payment) => {
        if (paymentType === "MEMBERSHIP") {
            return payment.paymentYear <= dayjs().year();
        }
        return true;
    });

    const filterByStatus = (payment, status) => {
        return status.includes(payment.paymentStatus);
    }

    const paymentSplit = {
        PAID: paymentList.filter((entry) => filterByStatus(entry, ["COMPLETED", "PAID"])),
        PENDING: paymentList.filter((entry) => filterByStatus(entry, ["PENDING"])),
        BLANK: paymentList.filter((entry) => filterByStatus(entry, [null])),
    }

    return (
        <SimpleBox gap={3}>
            <PaymentSummaryItem paymentSummary={paymentSplit.PENDING} type="PENDING" />
            <PaymentSummaryItem paymentSummary={paymentSplit.PAID} type="PAID" />
            <PaymentSummaryItem paymentSummary={paymentSplit.BLANK} type="BLANK" />
        </SimpleBox>
    )
}

export default PaymentSummary;
